import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { removeCookies, LEGACY_COOKIE_KEYS_TO_CLEANUP } from '@encarpkg/shared';
import ErrorBoundary from 'app/components/common/ErrorBoundary';
import {
	// co pages
	SnsLoginPage,
	EncarLoginPage,
	// us pages
	JoinPage,

	// cars pages
	CarsPage,

	// association pages
	AssociationPage,

	// my pages
	MyPage,

	// hs pages
	HomeservicePage,

	// redirect page
	RedirectPage,

	// loan pages
	LoanPage,

	// company pages
	CompanyPage,

	// landing pages
	LandingPage,
	NpsQaPage,

	// policy pages
	PolicyPage,

	// clean-encar pages
	PrivacyDocumentPage,
	DocumentBridgePage,
	DocumentTermsPage,

	// estimate pages
	EstimatePage,

	// DiagnosisIntro page
	DiagnosisPage,

	// PremiumDiagnosis page
	PremiumDiagnosisPage,

	// extended warranty pages
	ExtendedWarrantyPage,

	// encarcenter pages
	CenterPage,

	// imageUploader
	ImageUploaderPage,

	// compensation pages
	CompensationPage,

	// buyinquiry pages
	BuyInquiryPage,

	// encarpay pages
	EncarpayPage,

	// callback page
	CallbackPage,
	BoardPage,
	OhMyCallPage,
	EscrowPage,
	SelfRegisterPage,
	CarVerificationPage,
	EscrowV2Page,
	MeetgoPage,
	ContractsPage,
	UsedCarLoanPage,
	PreDeliveryPage,
	InspectionCenterPage,
	AccountManagement,
	ConsumerPage,
	ClientVerificationBlockedPage,
	CouponPage,
} from 'app/pages';

import '@encarpkg/design/dist/style.css';
import 'app/assets/scss/component/common.scss';

function App() {
	// 종료된 레거시 AB 테스트 쿠키 정리 (쿠키 용량 정리용)
	// TODO: 2026-10-06 이후 삭제 필요 (일회성 정리 목적)
	useEffect(() => {
		removeCookies(LEGACY_COOKIE_KEYS_TO_CLEANUP);
	}, []);

	return (
		<ErrorBoundary>
			<Switch>
				<Route
					path="/login"
					component={SnsLoginPage}
				/>
				<Route
					path="/encar-login"
					component={EncarLoginPage}
				/>
				<Route
					path="/join"
					component={JoinPage}
				/>
				<Route
					path="/cars"
					component={CarsPage}
				/>
				<Route
					path="/association"
					component={AssociationPage}
				/>
				<Route
					path="/my"
					component={MyPage}
				/>
				<Route
					path="/home-service"
					component={HomeservicePage}
				/>
				<Route
					path="/image-uploader"
					component={ImageUploaderPage}
				/>
				<Route
					path="/loan"
					component={LoanPage}
				/>
				<Route
					path="/landing"
					component={LandingPage}
				/>
				{!['prod', 'staging'].includes(process.env.REACT_APP_DEPLOY_ENV) && (
					<Route
						path="/qa/nps"
						component={NpsQaPage}
						exact
					/>
				)}
				<Route
					path="/callback"
					component={CallbackPage}
				/>
				<Route
					path="/company"
					component={CompanyPage}
				/>
				<Route
					path="/clean-encar/document/bridge"
					component={DocumentBridgePage}
				/>
				<Route
					path="/clean-encar/document/terms"
					component={DocumentTermsPage}
				/>
				<Route
					path="/clean-encar/document/upload"
					component={PrivacyDocumentPage}
				/>
				<Route
					path="/policy"
					component={PolicyPage}
				/>
				<Route
					path="/estimate"
					component={EstimatePage}
				/>
				<Route
					path="/encar-center"
					component={CenterPage}
				/>
				<Route
					path="/diagnosis"
					component={DiagnosisPage}
				/>
				<Route
					path="/premium-diagnosis"
					component={PremiumDiagnosisPage}
				/>
				<Route
					path="/encar-pay"
					component={EncarpayPage}
				/>
				<Route
					path="/extended-warranty"
					component={ExtendedWarrantyPage}
				/>
				<Route
					path="/compensation"
					component={CompensationPage}
				/>
				<Route
					path="/buyinquiry"
					component={BuyInquiryPage}
				/>
				<Route
					path="/board"
					component={BoardPage}
				/>
				<Route
					path="/ohmycall"
					component={OhMyCallPage}
				/>
				<Route
					path="/escrow"
					component={EscrowPage}
				/>
				<Route
					path="/self-register"
					component={SelfRegisterPage}
				/>
				<Route
					path="/car-verification"
					component={CarVerificationPage}
				/>
				<Route
					path="/escrow-v2"
					component={EscrowV2Page}
				/>
				<Route
					path="/meetgo"
					component={MeetgoPage}
				/>
				<Route
					path="/contracts"
					component={ContractsPage}
				/>
				<Route
					path="/usedcar-loan"
					component={UsedCarLoanPage}
				/>
				<Route
					path="/pre-delivery"
					component={PreDeliveryPage}
				/>
				<Route
					path="/inspection-center"
					component={InspectionCenterPage}
				/>
				<Route
					path="/account"
					component={AccountManagement}
				/>
				<Route
					path="/consumer"
					component={ConsumerPage}
				/>
				<Route
					path="/client-verification/blocked"
					component={ClientVerificationBlockedPage}
					exact
				/>
				<Route
					path="/coupon"
					component={CouponPage}
				/>
				<Route
					path="/"
					exact
					component={RedirectPage}
				/>
				<Route render={() => <RedirectPage type="404" />} />
			</Switch>
		</ErrorBoundary>
	);
}

export default App;
